module.exports = __webpack_public_path__ + "img/empty-state.a5319184.svg";